import { resolveResponseData } from './resolve-response-data';

/**
 * Fetches a POST method microservice call, resolves response data and returns the
 * response's data property value.
 *
 * @param {string} url
 * @param {object} [payload]
 */
export async function msPost<T>(url: string, payload?: object): Promise<T> {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        ...(payload
            ? {
                  body: JSON.stringify(payload),
              }
            : {}),
    });

    return resolveResponseData<T>(response);
}
